export default "__VITE_ASSET__DVdgK7bg__"